import React, { useState, useEffect, useRef } from "react";
import GetSignUpOffer from "../getSignUpOffer/getSignUpOffer";
import { Box, Grid, Typography, IconButton, Drawer } from "@mui/material";
import ProductSearchPanel from "../productSearchPanel/productSearchPanel";
import CustomLocationSelectField from "../uiElements/form/customLocationSelectField";
import { Link as RouterLink } from "react-router-dom";
import Navbar from "../navbar/navbar";
import ScrollableTabs from "../uiElements/scrollableTabList/scrollableTabList";
import {
  AccountBalance,
  Celebration,
  Description,
  Folder,
  Person,
  Work,
  Link,
  Menu as MenuIcon,
} from "@mui/icons-material";
import ScrollableWrestlerTabs from "../uiElements/scrollableWrestlerTabList/scrollableWrestlerTabList";
import CustomCategoryButton from "../uiElements/buttons/customCategoryButton";
import ResponsiveDialog from "../uiElements/dialog/responsiveDialog";
import SignInScreen from "src/screens/outerScreens/signin/signInScreen";
import SignInResponsiveDialog from "../uiElements/dialog/signInResponsiveDialog";
import CustomerProfileMenu from "../customer_profile_menu/customerProfileMenu";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "src/store/store";
import { fetchCart } from "src/redux/cart/cartSlice";
import { fetchWishlist } from "src/redux/wishlist/wishlistSlice";
import UseHeader from "./useHeader";
import { nextLocalStorage } from "src/components/api/helper/apiHelper";

import homeIcon from "src/assets/App/bottomMenu/bottomMenuHome.svg";
import homeIconHover from "src/assets/App/bottomMenu/bottomMenuHomeActive.svg";
import shoppingBag from "src/assets/App/bottomMenu/shoppingBag.svg";
import shoppingBagActive from "src/assets/App/bottomMenu/shoppingBagActive.svg";
import wishlist from "src/assets/App/bottomMenu/wishlist.svg";
import wishlistActive from "src/assets/App/bottomMenu/wishlistActive.svg";
import profile from "src/assets/App/bottomMenu/profile.svg";
import profileActive from "src/assets/App/bottomMenu/profileActive.svg";
import menuIcon from "src/assets/App/bottomMenu/menu.svg";
import menuIconActive from "src/assets/App/bottomMenu/menuActive.svg";
import ScrollableBottomMenu from "../scrollableBottomMenu/scrollableBottomMenu";
import CustomCountrySelect from "../uiElements/form/customCountrySelect";
import { useTranslation } from "react-i18next";
import { FormProvider } from "react-hook-form";
import CustomCategorySelect from "../uiElements/form/customCategorySelect";

const Header = () => {
  const { superStarList, promotionalPartnerList, formContext, onSubmit, formCountryContext, onCountrySubmit, selectCategoryList } =
    UseHeader();

  const [isSocialSignedIn, setIsSocialSignedIn] = useState(
    nextLocalStorage()?.getItem("SignInUser") === "True",
  );
  const isLoggedIn = !!sessionStorage.getItem("Token") || isSocialSignedIn;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [pendingProfileOpen, setPendingProfileOpen] = useState(false);
  const [showBottomMenu, setShowBottomMenu] = useState(false);
  const navigate = useNavigate();
  const cartProductCount = useSelector(
    (state: RootState) => state.cart.lineCount ?? state.cart.items.length,
  );
  const wishlistProductCount = useSelector(
    (state: RootState) => state.wishlist.items.length,
  );
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation("ManageOfferScreen");

  

  const { handleSubmit } = formContext;

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchCart());
      dispatch(fetchWishlist());
    } else {
      // If not logged in, clear cart
      // But since persist, maybe not, but for now, assume logout clears
    }
  }, [isLoggedIn, dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setShowBottomMenu(currentScrollY > 150);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDeleteDialogOpen = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleSignInSuccess = () => {
    setIsSocialSignedIn(true);
    handleDeleteDialogClose();
  };
  

  const bannerOptions = [
    {
      id: 1,
      label: "India",
      code: "in",
      icon: "https://flagcdn.com/w40/in.png",
      phone: "91",
    },
    {
      id: 2,
      label: "United States",
      code: "us",
      icon: "https://flagcdn.com/w40/us.png",
      phone: "1",
    },
    {
      id: 3,
      label: "Australia",
      code: "au",
      icon: "https://flagcdn.com/w40/au.png",
      phone: "61",
    },
  ];

  const tabAvatarStyle: React.CSSProperties = {
    width: 36,
    height: 36,
    borderRadius: "100%",
    objectFit: "cover",
  };

  const tabBrandLogoStyle: React.CSSProperties = {
    height: 28,
    objectFit: "cover",
  };

  const menus = [
    {
      id: "home",
      label: "Home",
      icon: (
        <Box
          component="img"
          src={homeIcon}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      activeIcon: (
        <Box
          component="img"
          src={homeIconHover}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      hoverIcon: (
        <Box
          component="img"
          src={homeIconHover}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
    },
    {
      id: "cart",
      label: "My Cart",
      icon: (
        <Box
          component="img"
          src={shoppingBag}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      activeIcon: (
        <Box
          component="img"
          src={shoppingBagActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      hoverIcon: (
        <Box
          component="img"
          src={shoppingBagActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      count: cartProductCount,
    },
    {
      id: "fav",
      label: "Wishlist",
      icon: (
        <Box
          component="img"
          src={wishlist}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      activeIcon: (
        <Box
          component="img"
          src={wishlistActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      hoverIcon: (
        <Box
          component="img"
          src={wishlistActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      count: wishlistProductCount,
    },
    {
      id: "profile",
      label: "Profile",
      icon: (
        <Box
          component="img"
          src={profile}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      activeIcon: (
        <Box
          component="img"
          src={profileActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      hoverIcon: (
        <Box
          component="img"
          src={profileActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
    },
    {
      id: "menu",
      label: "Menu",
      icon: (
        <Box
          component="img"
          src={menuIcon}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      activeIcon: (
        <Box
          component="img"
          src={menuIconActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
      hoverIcon: (
        <Box
          component="img"
          src={menuIconActive}
          alt="Home"
          sx={{ width: 24, height: 24 }}
        />
      ),
    },
  ];
  const [menu, setMenu] = useState("");

  const handleBottomMenuChange = (value: string) => {
    setMenu(value);
    const selectedMenu = menus.find((item) => item.id === value);
    if (selectedMenu?.id === "profile") {
      if (isLoggedIn) {
        navigate("/MyAccount");
      } else {
        handleDeleteDialogOpen();
      }
    } else if (selectedMenu?.id === "fav") {
      if (isLoggedIn) {
        navigate("/wishlist");
      } else {
        handleDeleteDialogOpen();
      }
    } else if (selectedMenu?.id === "cart") {
      if (isLoggedIn) {
        navigate("/shoppingCart");
      } else {
        navigate("/emptyCart");
      }
    } else if (selectedMenu?.id === "home") {
      navigate("/home");
    } else if (selectedMenu?.id === "menu") {
      setIsDrawerOpen(true);
    }
  };

  return (
    <>
      <Box sx={{ backgroundColor: "#000000" }}>
        <GetSignUpOffer />
        <Box
          sx={{
            px: 3,
            py: 1,
            //position: "sticky",
            //top: 0,
            //zIndex: 1300,
            //width: "100%",
          }}
        >
          <Grid container alignItems="center" spacing={2}>
            {/* 1️⃣ Logo & Hamburger */}
            <Grid item xs={6} sm={4} md={2} order={{ xs: 1, sm: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
                <IconButton
                  onClick={() => setIsDrawerOpen(true)}
                  sx={{
                    display: { xs: "flex", sm: "flex", md: "flex", lg: "none" },
                    color: "#fff",
                    p: 0.5,
                  }}
                >
                  <MenuIcon />
                </IconButton>
                <Box
                  component={RouterLink}
                  to="/"
                  sx={{ display: "inline-block" }}
                >
                  <Box
                    component="img"
                    src="/logo.png"
                    alt="logo"
                    sx={{
                      height: { xs: 40, sm: 50, md: 50 },
                      width: "auto",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* 2️⃣ Location */}
            <Grid
              item
              xs={6}
              sm={4}
              md={2}
              order={{ xs: 3, sm: 3 }}
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            >
              <FormProvider {...formCountryContext}>
                <form
                  onSubmit={handleSubmit(onCountrySubmit)}
                  noValidate
                  style={{ width: "100%" }}
                >
                  <CustomCountrySelect
                    name="BannerType"
                    fieldName="BannerTypeID"
                    valueKey="id"
                    labelKey="label"
                    iconKey="icon"
                    label={t("Location")}
                    placeholder={t("Select Location")}
                    options={bannerOptions}
                    control={formCountryContext.control}
                    sxProps={{ mt: 1, width: 1 }}
                  />
                  {/* <CustomLocationSelectField /> */}
                </form>
              </FormProvider>
            </Grid>

            {/* 3️⃣ Search */}
            <Grid item xs={12} sm={12} md={6} order={{ xs: 4, sm: 4 }}>
              <ProductSearchPanel
                onSearch={(term) => console.log("Searching for:", term)}
              />
            </Grid>

            {/* 4️⃣ Icons */}
            <Grid
              item
              xs={6}
              sm={4}
              md={2}
              order={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "flex-end",
                  md: "flex-end",
                },
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: 2, sm: 2, md: 2, lg: 4 },
                  alignItems: "center",
                }}
              >
                <Box>
                  <Box
                    onClick={(e) => {
                      e.preventDefault();
                      if (isLoggedIn) {
                        navigate(
                          wishlistProductCount > 0
                            ? "/Wishlist"
                            : "/Emptywishlist",
                        );
                      } else {
                        handleDeleteDialogOpen(); // open login dialog
                      }
                    }}
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      textDecoration: "none",
                      color: "#fff",
                      cursor: "pointer",
                      transition: "0.3s",
                      "&:hover": {
                        opacity: 0.7,
                      },
                    }}
                  >
                    <img
                      src="../Wishlist_icon.svg"
                      alt="Wishlist"
                      style={{ height: "20px" }}
                    />
                    <Box
                      sx={{
                        background: "#6A0DAD",
                        color: "#fff",
                        borderRadius: "100px",
                        padding: "5px",
                        position: "absolute",
                        bottom: "-5px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "18px",
                        height: "18px",
                      }}
                    >
                      <Typography sx={{ lineHeight: 1, fontSize: "10px" }}>
                        {wishlistProductCount}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ position: "relative" }}>
                  <Box
                    component={RouterLink}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        cartProductCount > 0 ? "/shoppingCart" : "/emptyCart",
                      );
                    }}
                    to="/emptyCart"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      textDecoration: "none",
                      position: "relative",
                      color: "#fff",
                      transition: "0.3s",
                      "&:hover": {
                        opacity: 0.7,
                      },
                    }}
                  >
                    <img
                      src="../shopping_bag.svg"
                      alt="Shopping Bag"
                      style={{ width: "20px", cursor: "pointer" }}
                    />
                    <Box
                      sx={{
                        background: "#6A0DAD",
                        color: "#fff",
                        borderRadius: "100px",
                        padding: "5px",
                        position: "absolute",
                        bottom: "-5px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "18px",
                        height: "18px",
                      }}
                    >
                      <Typography sx={{ lineHeight: 1, fontSize: "10px" }}>
                        {cartProductCount}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    textDecoration: "none",
                  }}
                >
                  {!isLoggedIn ? (
                    <Box
                      onClick={(e) => {
                        e.preventDefault();
                        handleDeleteDialogOpen();
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        textDecoration: "none",
                        color: "#fff",
                        transition: "0.3s",
                        "&:hover": {
                          opacity: 0.7,
                        },
                      }}
                    >
                      <img
                        src="../profile_icon.svg"
                        alt="Profile"
                        style={{ width: "20px", cursor: "pointer" }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        transition: "0.3s",
                      }}
                    >
                      <CustomerProfileMenu />
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ margin: "8px 0 0 25px" }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={2}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <FormProvider {...formContext}>
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  noValidate
                  style={{ width: "100%" }}
                >
                  <CustomCategorySelect
                    name="ProductCategoryName"
                    fieldName="ProductCategoryMasterID"
                    valueKey="ProductCategoryMasterID"
                    labelKey="ProductCategoryName"
                    iconKey="ImagePath"
                    placeholder={t("All Category")}
                    options={selectCategoryList}
                    control={formContext.control}
                    sxProps={{ mt: 1, width: 1 }}
                    onChange={(category) => {
                      if (category?.ProductCategoryMasterID) {
                        navigate("/shop", {
                          state: {
                            ProductCategoryMasterID:
                              category.ProductCategoryMasterID,
                          },
                        });
                      }
                    }}
                  />
                  {/* <CustomLocationSelectField /> */}
                </form>
              </FormProvider>
              {/* <CustomCategoryButton /> */}
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <Navbar
                mobileDrawerOpen={isDrawerOpen}
                onMobileDrawerClose={() => setIsDrawerOpen(false)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <ScrollableTabs
                onTabChange={(value) => {
                  navigate("/PromotionalPartner", {
                    state: { promotionalPartnerID: value },
                  });
                }}
                tabs={promotionalPartnerList.map((item: any) => ({
                  value: item.PromotionalPartnerMasterID.toString(),
                  icon: (
                    <img
                      src={item.ImagePath}
                      alt={item.PromotionalPartner}
                      style={tabBrandLogoStyle}
                    />
                  ),
                  content: <></>,
                }))}
              />
              {/* <ScrollableTabs
                tabs={[
                  {
                    value: "2",
                    icon: (
                      <img
                        src="../disney.png"
                        alt="John Cena"
                        style={tabBrandLogoStyle}
                      />
                    ),
                    content: <></>,
                  },
                ]}
              /> */}
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            marginTop: {
              xs: "10px",
              sm: "10px",
              md: "10px",
              lg: "0px",
              xl: "0px",
            },
          }}
        >
          <ScrollableWrestlerTabs
            onTabChange={(value) => {
              navigate("/shop", {
                state: { SuperStarMasterID: Number(value) },
              });
            }}
            tabs={superStarList.map((item: any) => ({
              label: item.SuperStarName,
              value: item.SuperStarMasterID.toString(),
              icon: (
                <img
                  src={item.ImagePath}
                  alt={item.SuperStarName}
                  style={tabAvatarStyle}
                />
              ),
              content: <></>,
            }))}
          />

          {/* <ScrollableWrestlerTabs
            tabs={[
              {
                label: "John Cena1",
                value: "2",
                icon: (
                  <img
                    src="../johncena.png"
                    alt="John Cena"
                    style={tabAvatarStyle}
                  />
                ),
                content: <></>,
              },
            ]}
          /> */}
        </Box>
      </Box>

      {/* Mobile drawer uses Navbar's own mobile drawer behaviour now */}

      <SignInResponsiveDialog
        open={isDeleteDialogOpen}
        handleClose={handleDeleteDialogClose}
      >
        <>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              order={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
            >
              <img
                src="/login_img.jpg"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              order={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
            >
              <SignInScreen onSignInSuccess={handleSignInSuccess} />
            </Grid>
          </Grid>
        </>
      </SignInResponsiveDialog>
      <Box
        sx={{
          display: {
            xs: showBottomMenu ? "block" : "none",
            sm: showBottomMenu ? "block" : "none",
            md: "none",
          },
          transition: "opacity 0.2s ease-in-out",
          opacity: showBottomMenu ? 1 : 0,
        }}
      >
        <ScrollableBottomMenu
          menus={menus}
          value={menu}
          onChange={handleBottomMenuChange}
        />
      </Box>
    </>
  );
};

export default Header;
